/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TypeCharacteristicFieldTypeEnum } from './typeCharacteristicFieldTypeEnum';


export interface CompositionCharacteristicsOfTypeDTO { 
    id?: string;
    sortOrder?: number;
    name?: string;
    isMandatory?: boolean;
    type?: TypeCharacteristicFieldTypeEnum;
    listValues?: Array<string>;
}
export namespace CompositionCharacteristicsOfTypeDTO {
}


